const CURRENCY_SYMBOLS = Object.freeze({
  CNY: '¥',
  USD: '$'
})

function normalizeCurrency(currency) {
  return typeof currency === 'string' ? currency.trim().toUpperCase() : ''
}

export function getCurrencySymbol(currency) {
  const normalizedCurrency = normalizeCurrency(currency)
  return CURRENCY_SYMBOLS[normalizedCurrency] || normalizedCurrency
}

export function formatCurrency(amount, currency) {
  const normalizedCurrency = normalizeCurrency(currency)
  const symbol = CURRENCY_SYMBOLS[normalizedCurrency]
  const value = amount === null || amount === undefined ? '' : String(amount)

  if (symbol) {
    return `${symbol}${value}`
  }

  return normalizedCurrency ? `${normalizedCurrency} ${value}`.trim() : value
}
